import classNames from "classnames";
import React from "react";

interface TextInputProps {
  disabled?: boolean;
  label?: string;
  name: string;
  required?: boolean;
  type: string;
  placeholder?: string;
  normal?: boolean;
  value: string | number;
  withOutLabel?: boolean;
  size?: string;
  min?: string | number;
  max?: string | number;
  className?: string;
  handleChange: (e: any) => void;
  positiveNumberOnly?: boolean;
  background?: string;
  textClass?: string;
}
export const TextInput: React.FC<TextInputProps> = ({
  disabled = false,
  label = "",
  name,
  required = false,
  type,
  normal = false,
  placeholder,
  value = "",
  handleChange,
  withOutLabel = false,
  size = "p-5",
  min,
  max,
  className,
  positiveNumberOnly = false,
  background = "bg-muted",
  textClass,
}) => {
  // normal means without boarder and radius

  const baseStyle = classNames(
    "w-full text-foreground bg-muted transition duration-200 ease-linear appearance-none focus:outline-none min-h-4 text-regular-2",
    size,
    textClass,
    background
  );
  const withRoundBorder = classNames(
    "rounded-xl border border-input focus:border-primary",
    size,
    background
  );
  const typePassword = "pr-16";

  return (
    <div className={classNames(className, "w-full flex flex-col hover:opacity-100")}>
      <div className="relative">
        {!withOutLabel && (
          <div className="flex justify-between">
            <label htmlFor={name} className="text-regular-2 pl-3 text-muted-foreground">
              {label}:{required && <span className="text-primary"> *</span>}
            </label>
          </div>
        )}
        <div className={normal ? "" : classNames(label !== "" ? "mt-2" : "", "relative")}>
          <input
            type={type}
            className={`${baseStyle} ${disabled && normal ? "text-right" : "text-left"} ${
              normal ? "" : withRoundBorder
            } ${type == "password" ? typePassword : ""}`}
            value={value}
            disabled={disabled ?? false}
            autoComplete="off"
            placeholder={placeholder}
            onKeyDown={(e) => {
              if (positiveNumberOnly && e.code === "Minus") {
                e.preventDefault();
              }
            }}
            onChange={(e) => {
              let value: string | number = e.target.value;

              if (max && value > max) {
                value = max;
              }

              handleChange(value);
            }}
            min={min}
            max={max}
          />
        </div>
      </div>
    </div>
  );
};
